import { Navigate } from 'react-router-dom';

import {
  Classify,
  SelectAdType,
  Write,
  Manage,
  Create,
  Refresh,
  Edit,
  EditPayAndPost,
  MultiLocation,
  RefreshError,
  Success,
} from 'src/app/v1/views/pages';
import type { FlowType } from 'src/types/jobFlow';

import {
  ROUTE_CLASSIFY,
  ROUTE_CONCIERGE,
  ROUTE_CREATE,
  ROUTE_EDIT,
  ROUTE_EDIT_PAY_AND_POST,
  ROUTE_EDIT_SUCCESS,
  ROUTE_GUARANTEED_HIRE,
  ROUTE_MANAGE,
  ROUTE_MULTI_LOCATION,
  ROUTE_PAY_AND_POST,
  ROUTE_PAY_AND_POST_V2,
  ROUTE_PREMIUM_PLUS,
  ROUTE_REFRESH,
  ROUTE_REFRESH_ERROR,
  ROUTE_REFRESH_SUCCESS,
  ROUTE_SELECT_AD_TYPE,
  ROUTE_SUCCESS,
  ROUTE_WRITE,
} from '../shared/constants/routes';
import CreateFlowContainer from '../v1/views/containers/CreateFlowContainer';
import EditFlowContainer from '../v1/views/containers/EditFlowContainer';
import MultiLocationContainer from '../v1/views/containers/MultiLocationContainer';
import RefreshFlowContainer from '../v1/views/containers/RefreshFlowContainer';
import {
  Concierge,
  GuaranteedHire,
  PremiumPlus,
} from '../v1/views/pages/JobAdBooking';
import { CreateFlowContainerV2 } from '../v2/containers/CreateFlowContainer/createFlowContainerV2';
import { PayAndPostPageV2 } from '../v2/pages/PayAndPostV2';

interface Route {
  flowType: FlowType;
  id: string;
  route: string;
  version: 1 | 2;
  element: JSX.Element;
}

export const routes: Route[] = [
  {
    flowType: 'create',
    id: ROUTE_CREATE,
    route: ROUTE_CREATE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Create />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_CLASSIFY,
    route: ROUTE_CLASSIFY,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Classify />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_SELECT_AD_TYPE,
    route: ROUTE_SELECT_AD_TYPE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <SelectAdType />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_WRITE,
    route: ROUTE_WRITE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Write />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_MANAGE,
    route: ROUTE_MANAGE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Manage />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_CONCIERGE,
    route: ROUTE_CONCIERGE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Concierge />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_GUARANTEED_HIRE,
    route: ROUTE_GUARANTEED_HIRE,
    version: 1,
    element: (
      <CreateFlowContainer>
        <GuaranteedHire />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_PREMIUM_PLUS,
    route: ROUTE_PREMIUM_PLUS,
    version: 1,
    element: (
      <CreateFlowContainer>
        <PremiumPlus />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_PAY_AND_POST,
    route: ROUTE_PAY_AND_POST,
    version: 1,
    element: (
      <Navigate to={`${ROUTE_PAY_AND_POST_V2}${window.location.search}`} />
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_PAY_AND_POST_V2,
    route: ROUTE_PAY_AND_POST_V2,
    version: 2,
    element: (
      <CreateFlowContainerV2>
        <PayAndPostPageV2 />
      </CreateFlowContainerV2>
    ),
  },
  {
    flowType: 'create',
    id: ROUTE_SUCCESS,
    route: ROUTE_SUCCESS,
    version: 1,
    element: (
      <CreateFlowContainer>
        <Success />
      </CreateFlowContainer>
    ),
  },
  {
    flowType: 'edit',
    id: ROUTE_EDIT,
    route: ROUTE_EDIT,
    version: 1,
    element: (
      <EditFlowContainer>
        <Edit />
      </EditFlowContainer>
    ),
  },
  {
    flowType: 'edit',
    id: ROUTE_EDIT_PAY_AND_POST,
    route: ROUTE_EDIT_PAY_AND_POST,
    version: 1,
    element: (
      <EditFlowContainer>
        <EditPayAndPost />
      </EditFlowContainer>
    ),
  },
  {
    flowType: 'edit',
    id: ROUTE_EDIT_SUCCESS,
    route: ROUTE_EDIT_SUCCESS,
    version: 1,
    element: (
      <EditFlowContainer>
        <Success />
      </EditFlowContainer>
    ),
  },
  {
    flowType: 'refresh',
    id: ROUTE_REFRESH,
    route: ROUTE_REFRESH,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <Refresh />
      </RefreshFlowContainer>
    ),
  },
  {
    flowType: 'refresh',
    id: ROUTE_REFRESH_SUCCESS,
    route: ROUTE_REFRESH_SUCCESS,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <Success />
      </RefreshFlowContainer>
    ),
  },
  {
    flowType: 'refresh',
    id: ROUTE_REFRESH_ERROR,
    route: ROUTE_REFRESH_ERROR,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <RefreshError />
      </RefreshFlowContainer>
    ),
  },
  {
    flowType: 'multilocation',
    id: ROUTE_MULTI_LOCATION,
    route: ROUTE_MULTI_LOCATION,
    version: 1,
    element: (
      <MultiLocationContainer>
        <MultiLocation />
      </MultiLocationContainer>
    ),
  },
];
